import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

class SimpleSelect extends React.Component {
  state = {
      Tier: 1,
      name: 'hai',
      labelWidth: 0,
  };
  componentWillMount() {
      const tiermapping = {
          'Tier1': 1,
          'Tier2': 2,
          'Tier3': 3
      }
      this.setState({Tier: tiermapping[this.props.Tier]})
  }
  componentDidMount() {

  }
  componentWillUpdate() {

  }
  handleChange = (event) => {
    console.log(event)
    this.setState({ [event.target.name]: event.target.value })
    this.props.handleSelect(event, this.props.id)

  };

  render() {
    const { classes } = this.props;

    return (
      <form className={classes.root} autoComplete="off">
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            value={this.state.Tier}
            onChange={(event)=>{this.handleChange(event)}}
            name="Tier"
            className={classes.selectEmpty}
            style={{fontSize:'15px'}}
        >
            <MenuItem value={1}>Tier 1</MenuItem>
            <MenuItem value={2}>Tier 2</MenuItem>
            <MenuItem value={3}>Tier 3</MenuItem>
          </Select>
        </FormControl>
      </form>
    );
  }
}

SimpleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleSelect);


// WEBPACK FOOTER //
// ./src/components/SharedComponents/dropdownselection.js